export default {
  system: {
    user: 'Usuário',
    level: 'Nível',
    earnPerTap: 'Ganho por toque',
    coinsToLevelUp: 'Moedas para subir de nível',
    profitPerHour: 'Lucro por hora',
    coming1: 'Algo interessante',
    coming2: 'chegando em breve...',
    close: 'Fechar',
    friends: 'Amigos',
    continue: 'Continuar',
  },
  settings: {
    chooseNetwork: 'Escolha a rede',
    chooseLanguage: 'Escolha o idioma',
  },
  popup_CheckTask: {
    join: 'Juntar-se',
    check: 'Verificar',
    taskIsNotCompleted: 'Tarefa não concluída',
  },
  popup_levelUp: {
    levelUp: 'Subiu de nível!',
    multiTap: 'Multitoque',
    energyLimit: 'Limite de energia',
  },
  popup_BalanceUp: {
    balanceUp: 'Atualização de saldo!',
    balanceDiffSinceLast: 'Sua recompensa',
  },
  popup_BalanceTip: {
    tip: 'Aumente seu lucro',
    message: 'Toque no menu Mina para comprar melhorias para sua rede',
    description: 'Ganhe mesmo quando offline por até 3 horas',
  },
  popup_Bored: {
    header: 'O sapo está entediado!',
    message: 'Brinque com o sapo.',
    description: 'Se o sapo não brincar por 3 horas, o lucro para',
  },
  popup_Hungry: {
    header: 'O sapo está com fome!',
    message: 'Alimente o sapo.',
    description: 'Quanto mais amigos você tiver, mais moedas cada alimentação pode trazer',
  },
  menu: {
    network: 'Rede',
    mine: 'Mina',
    earn: 'Ganhar',
    food: 'Comida',
  },
  tap: {
    bored: 'Entediado',
    fun: 'Divertido',
  },
  mineMenu: {
    activities: 'Atividades',
    investments: 'Investimentos',
    web3: 'WEB3',
    achievements: 'Conquistas',
  },
  leaderboard: {
    from: 'de',
    beTheFirst: 'Seja o primeiro!',
  },
  mine: {
    joinOurTG1: 'Junte-se ao nosso canal do Telegram,',
    joinOurTG2: 'para desbloquear!',
    unlock: 'Desbloquear',
  },
  friends: {
    inviteFriends: 'Convide amigos!',
    receiveBonuses: 'Você e seu amigo receberão bônus',
    inviteFriend: 'Convidar um amigo',
    withTelegramPremium: 'com Telegram Premium',
    forYouAndYourFriend: 'para você e seu amigo',
    moreBonuses: 'Mais bônus',
    listOfYourFriends: 'Lista dos seus amigos',
    linkCopied: 'O link de convite foi copiado para a sua área de transferência!',
    playWithMe:
      'Junte-se a mim e jogue para ganhar tokens através de um airdrop!\n' +
      '💰 Pegue seu presente! +3000 moedas para novos jogadores\n' +
      '🚀 Tem Telegram Premium? Ganhe +5000 moedas!\n',
  },
  earn: {
    moreCoins: 'Ganhe mais moedas!',
    dailyTasks: 'Tarefas diárias',
    dailyReward: 'Recompensa diária',
    tasksList: 'Lista de tarefas',
    joinOurTG: 'Junte-se ao nosso canal do Telegram',
    followOurX: 'Siga nossa conta no X',
    yourAd: 'Seu anúncio poderia estar aqui',
    connect: 'Entre em contato com o administrador do nosso canal do Telegram',
  },
  food: {
    hungry: 'Faminto',
    full: 'Cheio',
    frogIsFull: 'O sapo está satisfeito',
    feed: 'Alimentar',
    bonus: 'Bônus',
    satiety: 'Saciedade',
    hours: 'horas',
  },
  toast: {
    buyCard: {
      title: 'Conquista desbloqueada!',
      subtitle: 'Hora de levar seu império de sapos à grandeza 👑',
    },
    feedFrog: {
      title: 'O sapo está feliz!',
      subtitle: 'Ótimo trabalho! Alimente seu bichinho para manter os sorrisos 🍽️',
    },
  },
};
